import React from 'react'
import { RichTextRenderer } from 'packages/components/RichText'
import { PaperBlock, PaperQuestion } from 'packages/sdks-next/growp'
import styled from 'styled-components'
import { RenderAnswer } from '../Answers/RenderAnswer'
import { useAnswersManagement } from '../context'
import { formatStem, getMainQuestionStrNum } from '../utils'

export const CommonBlock: React.FC<{
  mainQuestion: PaperQuestion
  block: PaperBlock
  currentNum?: number
}> = ({ mainQuestion, block, currentNum }) => {
  const { blocks, showScore } = useAnswersManagement()
  const blockNum = getMainQuestionStrNum(blocks, block.id)
  const { type, stem, score } = mainQuestion
  const finalStem = formatStem({
    type,
    score,
    stem,
    showScore,
  })
  return (
    <Wrapper>
      <BlockNumWrapper>
        {currentNum ? `(${currentNum})` : `${blockNum}.`}
      </BlockNumWrapper>
      <Content>
        {mainQuestion.stem ? (
          <RichTextRenderer value={finalStem || ''} />
        ) : null}
        <RenderAnswer
          mainQuestion={mainQuestion}
          block={block}
        />
      </Content>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
`

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-grow: 1;
`

const BlockNumWrapper = styled.div`
  width: 24px;
  text-align: center;
  font-size: 14px;
  line-height: 22px;
  margin: 3px 0;
  font-weight: normal;
  color: ${(props) => props.theme.text._1};
`
